// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--Vnt","error":"ChangeForm__error--7Bf","captcha":"ChangeForm__captcha--2gZ","submit":"ChangeForm__submit--37C"};